import { Box, Typography, Chip, Stack } from '@mui/material';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { useMediaQuery } from 'hooks/useMediaQuery';

const SUGGESTIONS = [
    'Tóm tắt nội dung chính của tài liệu',
    'Các phát hiện hoặc kết luận quan trọng là gì?',
    'Giải thích chi tiết phần phương pháp nghiên cứu',
    'So sánh các quan điểm trong tài liệu'
];

export default function Hero({ className = '', onSuggestionClick }) {
    const { isMobile } = useMediaQuery();
    return (
        <Box
            className={className}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: isMobile ? 320 : 420,
                px: 2,
                py: 4
            }}
        >
            <Box
                sx={{
                    width: 72,
                    height: 72,
                    borderRadius: '50%',
                    bgcolor: 'primary.main',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2,
                    boxShadow: '0 8px 24px rgba(13, 148, 136, 0.25)'
                }}
            >
                <SummarizeIcon sx={{ fontSize: 40 }} />
            </Box>
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    textAlign: 'center',
                    mb: 1
                }}
            >
                Hỏi đáp tài liệu nghiên cứu
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    color: 'text.secondary',
                    textAlign: 'center',
                    maxWidth: 480,
                    mb: 2
                }}
            >
                Đặt câu hỏi dựa trên tài liệu đã chọn. Trợ lý sẽ trả lời dựa trên nội dung và trích dẫn nguồn.
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 3, width: '100%', maxWidth: 400 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ width: 28, height: 28, borderRadius: 1, bgcolor: 'primary.main', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', typography: 'caption', fontWeight: 700 }}>1</Box>
                    <Typography variant="body2" color="text.secondary">Chọn <strong>Knowledge</strong> (từ danh sách) hoặc <strong>Trợ lý / Dự án</strong> ở thanh phía trên.</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ width: 28, height: 28, borderRadius: 1, bgcolor: 'primary.main', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', typography: 'caption', fontWeight: 700 }}>2</Box>
                    <Typography variant="body2" color="text.secondary">Nhập câu hỏi vào ô bên dưới và gửi. Bạn có thể bấm gợi ý bên dưới.</Typography>
                </Box>
            </Box>
            {onSuggestionClick && (
                <>
                    <Typography variant="subtitle2" sx={{ color: 'text.secondary', mb: 1.5, fontWeight: 600 }}>Gợi ý câu hỏi</Typography>
                    <Stack direction="row" flexWrap="wrap" gap={1.5} justifyContent="center" useFlexGap>
                        {SUGGESTIONS.map((text, i) => (
                            <Chip
                                key={i}
                                label={text}
                                onClick={() => onSuggestionClick(text)}
                                sx={{
                                    borderRadius: 2,
                                    py: 1.25,
                                    fontSize: '0.9rem',
                                    bgcolor: 'primary.50',
                                    color: 'primary.dark',
                                    border: '1px solid',
                                    borderColor: 'primary.light',
                                    '&:hover': { bgcolor: 'primary.100', borderColor: 'primary.main' }
                                }}
                            />
                        ))}
                    </Stack>
                </>
            )}
        </Box>
    );
}
